export default "__VITE_PUBLIC_ASSET__b9b640f3__"